import { useState } from "react";
import { Link } from "react-router-dom";
import { AlertTriangle, FileSearch } from "lucide-react";
import PaginaFiscal from "../_components/pagina-fiscal";
import TabelaSefaz from "./_components/tabela-sefaz";
import FiltroSefaz from "./_components/filtro-sefaz";
import { useAcoesFiscais, useConsultaFiscal, usePaginacao } from "../hooks";
import { baixarXmlSefaz, listarChavesSefaz } from "../api/sefaz";

export default function NotasSefaz() {
	const [retorno, setRetorno] = useState(null);
	const [situacoes, setSituacoes] = useState({});
	const [baixando, setBaixando] = useState(null);

	const consulta = useConsultaFiscal(async (f) => {
		setRetorno(null);
		setSituacoes({});
		const dados = await listarChavesSefaz(f);
		setRetorno(dados);
		return dados.chaves.sort((a, b) => b.numero - a.numero);
	}, "filtroNotasSefaz");
	const paginacao = usePaginacao(consulta.itens);

	const acoes = useAcoesFiscais({
		baixarXml: async ({ chave }) => {
			const situacao = await baixarXmlSefaz(chave);
			setSituacoes((atuais) => ({ ...atuais, [chave]: situacao }));
		},
	});

	async function baixar(item) {
		setBaixando(item.chave);
		await acoes.executar("baixarXml", item);
		setBaixando(null);
	}

	return (
		<PaginaFiscal
			icone={FileSearch}
			titulo="Consulta na SEFAZ"
			subtitulo="Busca na SEFAZ-SP as NFC-e emitidas no período"
			consulta={consulta}
			filtro={FiltroSefaz}
			acoes={acoes}
		>
			<div className="flex items-start gap-2 p-3 bg-amber-50 rounded border border-amber-200 text-sm text-amber-800">
				<AlertTriangle size={16} className="mt-0.5 shrink-0" />
				<p>
					Consulta direta na SEFAZ-SP para conferência e recuperação de XML. A SEFAZ guarda apenas os últimos
					100 dias e limita o número de consultas por minuto; para o dia a dia, use a tela{" "}
					<Link to="/fiscal/documentos" className="font-semibold underline">
						Documentos
					</Link>
					.
				</p>
			</div>

			{retorno && (
				<p className="text-sm text-gray-600">
					Retorno da SEFAZ: {retorno.cstat} · {retorno.motivo}
				</p>
			)}

			<TabelaSefaz
				chaves={paginacao.itensPagina}
				total={consulta.itens.length}
				pagina={paginacao.pagina}
				totalPaginas={paginacao.totalPaginas}
				onPagina={paginacao.setPagina}
				carregando={consulta.carregando}
				jaBuscou={!!consulta.filtrosAplicados}
				situacoes={situacoes}
				baixando={baixando}
				onBaixar={baixar}
			/>
		</PaginaFiscal>
	);
}
